import React, { useState } from 'react';
import { MessageSquareIcon, SearchIcon, FilterIcon, SendIcon, PaperclipIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, XCircleIcon, MailIcon, PhoneIcon } from 'lucide-react';
const tickets = [{
  id: 'TKT-1001',
  type: 'complaint',
  subject: 'Service quality issue',
  customer: {
    name: 'Kosta Deris',
    email: 'kosta@example.com',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  bookingId: '1409',
  priority: 'high',
  status: 'open',
  createdAt: '2025-11-12 10:30 AM',
  lastUpdate: '2025-11-12 2:15 PM',
  assignedTo: 'Sarah Johnson',
  messages: [{
    id: 1,
    sender: 'customer',
    name: 'Kosta Deris',
    text: 'The service provider did not complete the job as agreed. There are several issues with the installation.',
    timestamp: '2025-11-12 10:30 AM'
  }, {
    id: 2,
    sender: 'support',
    name: 'Sarah Johnson',
    text: 'Thank you for reaching out. I am reviewing your booking details and will get back to you shortly with a resolution.',
    timestamp: '2025-11-12 2:15 PM'
  }]
}, {
  id: 'TKT-1002',
  type: 'dispute',
  subject: 'Payment dispute for booking #1408',
  customer: {
    name: 'Ken Matsumoto',
    email: 'ken@example.com',
    avatar: 'https://i.pravatar.cc/150?img=3'
  },
  bookingId: '1408',
  priority: 'medium',
  status: 'in-progress',
  createdAt: '2025-11-11 3:45 PM',
  lastUpdate: '2025-11-12 9:00 AM',
  assignedTo: 'Mike Chen',
  messages: [{
    id: 1,
    sender: 'customer',
    name: 'Ken Matsumoto',
    text: 'I was charged twice for the same booking. Please review and refund the duplicate charge.',
    timestamp: '2025-11-11 3:45 PM'
  }, {
    id: 2,
    sender: 'support',
    name: 'Mike Chen',
    text: 'I have located the duplicate charge in our system. Processing the refund now.',
    timestamp: '2025-11-12 9:00 AM'
  }]
}, {
  id: 'TKT-1003',
  type: 'refund',
  subject: 'Refund request for cancelled service',
  customer: {
    name: 'Sarah Johnson',
    email: 'sarah@example.com',
    avatar: 'https://i.pravatar.cc/150?img=4'
  },
  bookingId: '1402',
  priority: 'low',
  status: 'resolved',
  createdAt: '2025-11-10 1:20 PM',
  lastUpdate: '2025-11-11 4:30 PM',
  assignedTo: 'Sarah Johnson',
  messages: [{
    id: 1,
    sender: 'customer',
    name: 'Sarah Johnson',
    text: 'The service provider cancelled last minute. I would like a full refund.',
    timestamp: '2025-11-10 1:20 PM'
  }, {
    id: 2,
    sender: 'support',
    name: 'Sarah Johnson',
    text: 'Your refund has been processed and should appear in your account within 3-5 business days.',
    timestamp: '2025-11-11 4:30 PM'
  }]
}, {
  id: 'TKT-1004',
  type: 'complaint',
  subject: 'Pro arrived late',
  customer: {
    name: 'David Lee',
    email: 'david@example.com',
    avatar: 'https://i.pravatar.cc/150?img=5'
  },
  bookingId: '1395',
  priority: 'medium',
  status: 'open',
  createdAt: '2025-11-12 8:15 AM',
  lastUpdate: '2025-11-12 8:15 AM',
  assignedTo: null,
  messages: [{
    id: 1,
    sender: 'customer',
    name: 'David Lee',
    text: 'The service provider was 45 minutes late without any notification. This caused significant inconvenience.',
    timestamp: '2025-11-12 8:15 AM'
  }]
}];
export const CustomerSupportPage = () => {
  const [selectedTicket, setSelectedTicket] = useState(tickets[0]);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const [messageText, setMessageText] = useState('');
  const filteredTickets = tickets.filter(ticket => {
    const matchesSearch = ticket.subject.toLowerCase().includes(searchQuery.toLowerCase()) || ticket.customer.name.toLowerCase().includes(searchQuery.toLowerCase()) || ticket.id.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || ticket.status === statusFilter;
    const matchesType = typeFilter === 'all' || ticket.type === typeFilter;
    return matchesSearch && matchesStatus && matchesType;
  });
  const handleSendMessage = () => {
    if (messageText.trim()) {
      console.log('Sending message:', messageText);
      setMessageText('');
    }
  };
  return <div className="p-6 h-full flex flex-col" data-id="element-646">
      <div className="mb-6" data-id="element-647">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-648">Customer Support</h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-649">
          Manage tickets, complaints, and customer communications
        </p>
      </div>
      <div className="grid grid-cols-4 gap-4 mb-6" data-id="element-650">
        <StatCard icon={<ClockIcon className="text-orange-600" size={24} data-id="element-652" />} label="Open Tickets" value={tickets.filter(t => t.status === 'open').length} color="orange" data-id="element-651" />
        <StatCard icon={<AlertCircleIcon className="text-blue-600" size={24} data-id="element-654" />} label="In Progress" value={tickets.filter(t => t.status === 'in-progress').length} color="blue" data-id="element-653" />
        <StatCard icon={<CheckCircleIcon className="text-green-600" size={24} data-id="element-656" />} label="Resolved" value={tickets.filter(t => t.status === 'resolved').length} color="green" data-id="element-655" />
        <StatCard icon={<XCircleIcon className="text-gray-600" size={24} data-id="element-658" />} label="Closed" value={tickets.filter(t => t.status === 'closed').length} color="gray" data-id="element-657" />
      </div>
      <div className="flex-1 grid grid-cols-5 gap-6 min-h-0" data-id="element-659">
        <div className="col-span-2 bg-white rounded-lg shadow border border-gray-100 flex flex-col" data-id="element-660">
          <div className="p-4 border-b border-gray-200" data-id="element-661">
            <div className="relative mb-3" data-id="element-662">
              <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-663" />
              <input type="text" placeholder="Search tickets..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-664" />
            </div>
            <div className="flex items-center space-x-2" data-id="element-665">
              <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-666">
                <option value="all" data-id="element-667">All Status</option>
                <option value="open" data-id="element-668">Open</option>
                <option value="in-progress" data-id="element-669">In Progress</option>
                <option value="resolved" data-id="element-670">Resolved</option>
                <option value="closed" data-id="element-671">Closed</option>
              </select>
              <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-672">
                <option value="all" data-id="element-673">All Types</option>
                <option value="complaint" data-id="element-674">Complaints</option>
                <option value="dispute" data-id="element-675">Disputes</option>
                <option value="refund" data-id="element-676">Refunds</option>
              </select>
            </div>
          </div>
          <div className="flex-1 overflow-y-auto" data-id="element-677">
            {filteredTickets.map(ticket => <TicketItem key={ticket.id} ticket={ticket} isSelected={selectedTicket?.id === ticket.id} onClick={() => setSelectedTicket(ticket)} data-id="element-678" />)}
          </div>
        </div>
        <div className="col-span-3 bg-white rounded-lg shadow border border-gray-100 flex flex-col" data-id="element-679">
          {selectedTicket ? <>
              <div className="p-4 border-b border-gray-200" data-id="element-680">
                <div className="flex items-start justify-between mb-4" data-id="element-681">
                  <div className="flex-1" data-id="element-682">
                    <div className="flex items-center space-x-2 mb-2" data-id="element-683">
                      <h2 className="text-lg font-semibold text-gray-800" data-id="element-684">
                        {selectedTicket.subject}
                      </h2>
                      {getTypeBadge(selectedTicket.type)}
                      {getPriorityBadge(selectedTicket.priority)}
                    </div>
                    <div className="flex items-center space-x-4 text-sm text-gray-500" data-id="element-685">
                      <span data-id="element-686">Ticket #{selectedTicket.id}</span>
                      <span data-id="element-687">•</span>
                      <span data-id="element-688">Booking #{selectedTicket.bookingId}</span>
                      <span data-id="element-689">•</span>
                      <span data-id="element-690">{selectedTicket.createdAt}</span>
                    </div>
                  </div>
                  <select value={selectedTicket.status} className="px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-691">
                    <option value="open" data-id="element-692">Open</option>
                    <option value="in-progress" data-id="element-693">In Progress</option>
                    <option value="resolved" data-id="element-694">Resolved</option>
                    <option value="closed" data-id="element-695">Closed</option>
                  </select>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-696">
                  <div className="flex items-center" data-id="element-697">
                    <img src={selectedTicket.customer.avatar} alt={selectedTicket.customer.name} className="h-10 w-10 rounded-full mr-3" data-id="element-698" />
                    <div data-id="element-699">
                      <p className="text-sm font-medium text-gray-900" data-id="element-700">
                        {selectedTicket.customer.name}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-701">
                        {selectedTicket.customer.email}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-702">
                    <button className="p-2 hover:bg-gray-200 rounded-full" data-id="element-703">
                      <MailIcon size={18} className="text-gray-600" data-id="element-704" />
                    </button>
                    <button className="p-2 hover:bg-gray-200 rounded-full" data-id="element-705">
                      <PhoneIcon size={18} className="text-gray-600" data-id="element-706" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex-1 overflow-y-auto p-4 space-y-4" data-id="element-707">
                {selectedTicket.messages.map(message => <MessageBubble key={message.id} message={message} data-id="element-708" />)}
              </div>
              <div className="p-4 border-t border-gray-200" data-id="element-709">
                <div className="flex items-end space-x-2" data-id="element-710">
                  <button className="p-2 hover:bg-gray-100 rounded-md" data-id="element-711">
                    <PaperclipIcon size={20} className="text-gray-500" data-id="element-712" />
                  </button>
                  <textarea value={messageText} onChange={e => setMessageText(e.target.value)} placeholder="Type your response..." className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none" rows={3} data-id="element-713" />
                  <button onClick={handleSendMessage} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center h-fit" data-id="element-714">
                    <SendIcon size={16} className="mr-2" data-id="element-715" />
                    Send
                  </button>
                </div>
              </div>
            </> : <div className="flex-1 flex items-center justify-center text-gray-400" data-id="element-716">
              <div className="text-center" data-id="element-717">
                <MessageSquareIcon size={48} className="mx-auto mb-3" data-id="element-718" />
                <p data-id="element-719">Select a ticket to view conversation</p>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
const StatCard = ({
  icon,
  label,
  value,
  color
}) => {
  const colorClasses = {
    orange: 'bg-orange-100',
    blue: 'bg-blue-100',
    green: 'bg-green-100',
    gray: 'bg-gray-100'
  };
  return <div className="bg-white rounded-lg shadow border border-gray-100 p-4" data-id="element-720">
      <div className="flex items-center justify-between" data-id="element-721">
        <div data-id="element-722">
          <p className="text-sm text-gray-500" data-id="element-723">{label}</p>
          <p className="text-2xl font-bold text-gray-800 mt-1" data-id="element-724">{value}</p>
        </div>
        <div className={`h-12 w-12 ${colorClasses[color]} rounded-full flex items-center justify-center`} data-id="element-725">
          {icon}
        </div>
      </div>
    </div>;
};
const TicketItem = ({
  ticket,
  isSelected,
  onClick
}) => {
  return <div onClick={onClick} className={`p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50 ${isSelected ? 'bg-blue-50' : ''}`} data-id="element-726">
      <div className="flex items-start justify-between mb-2" data-id="element-727">
        <div className="flex-1" data-id="element-728">
          <div className="flex items-center space-x-2 mb-1" data-id="element-729">
            <span className="text-sm font-semibold text-gray-800" data-id="element-730">
              {ticket.id}
            </span>
            {getTypeBadge(ticket.type)}
            {getPriorityBadge(ticket.priority)}
          </div>
          <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-731">
            {ticket.subject}
          </p>
          <div className="flex items-center space-x-2 text-xs text-gray-500" data-id="element-732">
            <img src={ticket.customer.avatar} alt={ticket.customer.name} className="h-5 w-5 rounded-full" data-id="element-733" />
            <span data-id="element-734">{ticket.customer.name}</span>
          </div>
        </div>
        {getStatusBadge(ticket.status)}
      </div>
      <div className="flex items-center justify-between text-xs text-gray-500" data-id="element-735">
        <span data-id="element-736">{ticket.createdAt}</span>
        {ticket.assignedTo && <span data-id="element-737">Assigned to {ticket.assignedTo}</span>}
      </div>
    </div>;
};
const MessageBubble = ({
  message
}) => {
  const isCustomer = message.sender === 'customer';
  return <div className={`flex ${isCustomer ? 'justify-start' : 'justify-end'}`} data-id="element-738">
      <div className={`max-w-[70%] ${isCustomer ? 'bg-gray-100' : 'bg-blue-600 text-white'} rounded-lg p-3`} data-id="element-739">
        <div className="flex items-center space-x-2 mb-1" data-id="element-740">
          <span className="text-xs font-medium" data-id="element-741">{message.name}</span>
          <span className={`text-xs ${isCustomer ? 'text-gray-500' : 'text-blue-200'}`} data-id="element-742">
            {message.timestamp}
          </span>
        </div>
        <p className="text-sm" data-id="element-743">{message.text}</p>
      </div>
    </div>;
};
const getStatusBadge = status => {
  const statusConfig = {
    open: {
      label: 'Open',
      color: 'bg-orange-500 text-white'
    },
    'in-progress': {
      label: 'In Progress',
      color: 'bg-blue-500 text-white'
    },
    resolved: {
      label: 'Resolved',
      color: 'bg-green-500 text-white'
    },
    closed: {
      label: 'Closed',
      color: 'bg-gray-500 text-white'
    }
  };
  const config = statusConfig[status] || statusConfig.open;
  return <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${config.color}`} data-id="element-744">
      {config.label}
    </span>;
};
const getTypeBadge = type => {
  const typeConfig = {
    complaint: {
      label: 'Complaint',
      color: 'bg-red-100 text-red-700'
    },
    dispute: {
      label: 'Dispute',
      color: 'bg-yellow-100 text-yellow-700'
    },
    refund: {
      label: 'Refund',
      color: 'bg-purple-100 text-purple-700'
    }
  };
  const config = typeConfig[type];
  return <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${config.color}`} data-id="element-745">
      {config.label}
    </span>;
};
const getPriorityBadge = priority => {
  const priorityConfig = {
    high: {
      label: 'High',
      color: 'bg-red-100 text-red-700'
    },
    medium: {
      label: 'Medium',
      color: 'bg-orange-100 text-orange-700'
    },
    low: {
      label: 'Low',
      color: 'bg-gray-100 text-gray-700'
    }
  };
  const config = priorityConfig[priority];
  return <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${config.color}`} data-id="element-746">
      {config.label}
    </span>;
};